/*
 * @Author: Jhonsem
 * @Date: 2019-09-10 14:57:39
 * @Last Modified by: Jhonsem
 * @Last Modified time: 2019-09-11 14:42:17
 */
import store from "@/vuex/store";
import LocalStorageWorker from "./localstorage";

const FIRST_ENTER_TIME_STAMP = "firstEnterTimeStamp";
const ENTER_TIMES = "enterTimes";
const PAY_WAY_TIMES = "payWayTimes";
const HAS_ENTERED = "hasEntered";
/**
 * 记录第一次进入的时间戳
 */
export const recordFirstEnterTimeStamp = () => {
  if (!LocalStorageWorker.has(FIRST_ENTER_TIME_STAMP)) {
    LocalStorageWorker.set(FIRST_ENTER_TIME_STAMP, new Date().valueOf());
  }
};

/**
 * 获取第一次进入的时间戳
 */
export const getFirstEnterTimeStamp = () => {
  return parseInt(LocalStorageWorker.get(FIRST_ENTER_TIME_STAMP));
};

/**
 * 记录进入的次数
 */
export const recordEnterTimes = () => {
  if (!LocalStorageWorker.has(ENTER_TIMES)) {
    LocalStorageWorker.set(ENTER_TIMES, 1);
    LocalStorageWorker.set(HAS_ENTERED, "entered", true);
  } else {
    if (!LocalStorageWorker.has(HAS_ENTERED, true)) {
      const enterTimes = parseInt(LocalStorageWorker.get(ENTER_TIMES));
      LocalStorageWorker.set(ENTER_TIMES, enterTimes + 1);
      LocalStorageWorker.set(HAS_ENTERED, "entered", true);
    }
  }
};
/**
 * 获取进入的次数
 */
export const getEnterTimes = () => {
  return parseInt(LocalStorageWorker.get(ENTER_TIMES));
};

const setPayWayTime = (type, pay_record) => {
  for (const key in pay_record) {
    if (type === key) {
      pay_record[key] += 1;
    }
  }
  LocalStorageWorker.set(PAY_WAY_TIMES, pay_record);
};

/**
 * 记录购买的次数
 * @param {*} type string  1.iap 2.paypal 3.cash 4.card
 */
export const recordPayWayTimes = type => {
  if (!LocalStorageWorker.has(PAY_WAY_TIMES)) {
    // 初始化购买参数：
    const pay_record = {
      iap: 0,
      paypal: 0,
      cash: 0,
      card: 0
    };
    setPayWayTime(type, pay_record);
  } else {
    const pay_record = LocalStorageWorker.get(PAY_WAY_TIMES);
    setPayWayTime(type, pay_record);
  }
};

/**
 * 获取get pay way times
 * @param {*} type
 */
export const getPayWayTimes = type => {
  console.log("LocalStorageWorker:", LocalStorageWorker);
  const pay_record = LocalStorageWorker.get(PAY_WAY_TIMES);
  if (pay_record) {
    return type ? pay_record[type] : pay_record;
  } else {
    const pay_record = {
      iap: 0,
      paypal: 0,
      cash: 0,
      card: 0
    };
    setPayWayTime(type, pay_record);
    return pay_record;
  }
};

export const isBigPirce = (store, price) => {
  const settingData = store.state.settingData;
  const brg_prices =
    settingData && settingData.sale && settingData.sale.big_prices;

  return brg_prices.includes(price);
};

export const findFeature = (store, offer, payWay) => {
  const price = offer.iap.price;
  const isBigPirceRes = isBigPirce(store, price);
  const settingData = store.state.settingData;
  const features =
    settingData &&
    settingData.client_settings &&
    settingData.client_settings.features;
  if (payWay === "paypal") {
    const featruesName = isBigPirceRes ? "big_pp_way" : "small_pp_way";
    return features.find(ft => {
      return ft.function === featruesName;
    });
  }
};

export const canShowPayment = (store, offer, payWay) => {
  const feature = findFeature(store, offer, payWay);

  const payWayTimes = getPayWayTimes();
  const app_launch_time = getEnterTimes();
  const first_enter_timestamp = getFirstEnterTimeStamp();
  const { is_enabled, delay, event } = feature;

  const iap_purchase_time = payWayTimes.iap;
  const paypal_purchase_time = payWayTimes.paypal;
  const card_purchase_time = payWayTimes.card;

  // 总支付次数
  const purchase_sum =
    iap_purchase_time + paypal_purchase_time + card_purchase_time;
  if (!is_enabled) {
    return false;
  }
  const or_open_app = event.find(event => {
    return event.eventName === "or_open_app";
  });
  const open_app = event.find(event => {
    return event.eventName === "open_app";
  });
  const pay_by_iap = event.find(event => {
    return event.eventName === "pay_by_iap";
  });
  const pay_by_cash = event.find(event => {
    return event.eventName === "pay_by_cash";
  });
  const delay_action =
    new Date().getTime() - first_enter_timestamp > delay * 1000;
  const judge_or_open_app =
    !or_open_app || (or_open_app && app_launch_time >= or_open_app.count);
  const judge_open_app =
    !open_app || (open_app && app_launch_time >= open_app.count);
  const judge_pay_by_iap =
    !pay_by_iap || (pay_by_iap && iap_purchase_time >= pay_by_iap.count);
  const judge_pay_by_cash =
    !pay_by_cash || (pay_by_cash && purchase_sum >= pay_by_cash.count);
  return (
    is_enabled &&
    delay_action &&
    (judge_or_open_app ||
      (judge_open_app && judge_pay_by_iap && judge_pay_by_cash))
  );
};



// WEBPACK FOOTER //
// ./src/utils/payment.js